import { getFormatMessage } from '@/utils/utils'
import { Modal } from 'antd'

export type RebootArgs = {
  waiting: number
  onCountDown: (time: number) => void
}

export function rebootCountDown(
  reboot: () => Promise<void>,
  args?: RebootArgs
): Promise<void> {
  return new Promise((resolve, reject) => {
    reboot()
      .then(() => {
        if (!args) {
          resolve()
          return
        }
        let secondsToGo = args.waiting
        const timer = setInterval(() => {
          secondsToGo -= 1
          if (secondsToGo >= 0) {
            args.onCountDown(secondsToGo)
          }
        }, 1000)
        setTimeout(() => {
          clearInterval(timer)
          resolve()
        }, (secondsToGo + 1) * 1000)
      })
      .catch(() => reject())
  })
}

export function showRebootModal(reboot: () => Promise<void>) {
  const formatMessage = getFormatMessage()
  const modal = Modal.confirm({
    title: formatMessage({ id: 'app.modal.title' }),
    content: formatMessage({ id: 'app.modal.reboot.confirm' }),
    onOk: async () => {
      modal.update({
        content: formatMessage({
          id: 'app.modal.reboot.message'
        })
      })
      await reboot()
    }
  })
}
